"use client";
import { RichTextRender } from "@/components/ui/RichTextRender";
import type { BlokText } from "@/storyblok";
import type { BlokProps } from "@frend-digital/storyblok";
import { clsx } from "@frend-digital/ui";
import BlokWrap from "../BlokWrap";
import styles from "./TextBlok.module.css";
import { SegmentControl } from "@/components/SegmentControl";

export const TextBlok = ({
	blok,
	preview,
	className,
	small,
}: BlokProps<BlokText> & { className?: string; small?: boolean }) => {
	//.
	return (
		<SegmentControl segments={blok}>
			<BlokWrap editable={blok} asChild>
				<div
					className={clsx(
						styles.root,
						className,
						blok.layout === "sideBySide" && styles.sideBySide,
						blok.layout === "center" && styles.center,
						blok.layout === "left" && styles.left,
					)}
				>
					{blok.title && (
						<h2 className={clsx(styles.title, blok.headingSize && styles[blok.headingSize])}>
							{blok.title}
						</h2>
					)}
					<div className={styles.text}>
						<RichTextRender
							small={small}
							blok={blok.text!}
							preview={preview}
							openExternalLinksInNewWindow={blok.openExternalLinksInNewWindow}
						/>
					</div>
				</div>
			</BlokWrap>
		</SegmentControl>
	);
};
